// src/assets/index.js

// Import all images
import twoStudentsReading from './images/2studentsreading.JPG';
import aboutSection from './images/aboutsection.JPG';
import adjudicators from './images/adjudicators.JPG';
import aLadyDebating from './images/aladydebating.JPG';
import arrival2 from './images/arrival2.jpg';
import arrival3 from './images/arrival3.jpg';
import arrivals from './images/arrivals.jpg';
import attentiveToDetails from './images/attentivetodetails.JPG';
import audience from './images/audience.JPG';
import aVoiceInACrowd from './images/avoiceinacrowd.jpg';
import champes from './images/champes.JPG';
import champions from './images/champions.jpg';
import coaches2 from './images/coaches2.jpg';
import congrats from './images/congrats.jpg';
import coordinators from './images/cordinators.jpg';
import debateCoaches from './images/debatecoaches.JPG';
import doYouGetMe from './images/doyougetme.jpg';
import friendsMoment from './images/friendsmoment.jpg';
import funMoment from './images/funmoment.JPG';
import guestSpeaker from './images/guestspeaker.jpg';
import happyMoment from './images/happymoment.jpg';
import hearMeOut from './images/hearmeout.JPG';
import iGotThis from './images/igotthis.jpg';
import inAction from './images/inaction.JPG';
import innovation from './images/innovation.jpg';
import kidsFunCameraMoment from './images/kidsfuncameramoment.jpg';
import kidsWithTrophies from './images/kidswithtrophies.JPG';
import ladyAdjudicator from './images/ladyadjudicator.JPG';
import letsPray from './images/letspray.jpg';
import metANewFriend from './images/metanewfriend.jpg';
import momDaughterMoment from './images/momdaughtermoment.jpg';
import noItsYou from './images/noitsyou.jpg';
import oneTeam from './images/oneteam.jpg';
import oneVoice from './images/onevoice.JPG';
import onIt from './images/onit.JPG';
import parade from './images/parade.jpg';
import pointHome from './images/pointhome.JPG';
import receivingAwards from './images/receivingawards.JPG';
import saySomethingOnMic from './images/saysomethingonmic.jpg';
import smilee from './images/smilee.JPG';
import studentDebating from './images/studentdebating.JPG';
import studentsInCompetition from './images/studentsincompetition.JPG';
import teacherWithStudentMoment from './images/teacherwithstudentmoment.jpg';
import teamGettingAwards from './images/teamgettingawards.JPG';
import thatsTheStage from './images/thatsthestage.jpg';
import theWinners from './images/thewinners.JPG';
import thisIsRight from './images/thisisright.JPG';
import trophies from './images/trophies.jpg';
import weAreTheChampions from './images/wearethechampions.jpg';
import weGonnaWinThis from './images/wegonnawinthis.jpg';
import weGotThis from './images/wegotthis.JPG';
import logo from './images/debaters.jpg';
import oxford from './images/oxford.jpg';
import learning from './images/learning.jpg';
import unihawk from './images/unihawk.jpg';
import absa from './images/absa.png';
import toloita from './images/toloita.webp';

// Organized by categories
export const heroImages = {
  primary: inAction,
  secondary: studentDebating,
  background: aboutSection
};

export const featuresBackground = {
  main: studentsInCompetition,
  alternative: attentiveToDetails
};

export const programImages = {
  debateClubs: twoStudentsReading,
  exchanges: metANewFriend,
  teaching: teacherWithStudentMoment,
  leadership: iGotThis,
  speaking: saySomethingOnMic
};

export const testimonialImages = {
  student1: aLadyDebating,
  student2: hearMeOut,
  student3: pointHome
};

export const aboutImages = {
  main: aboutSection,
  team: oneTeam,
  coaches: debateCoaches,
  coordinators: coordinators
};

export const galleryImages = {
  competitions: [
    studentsInCompetition,
    inAction,
    studentDebating,
    thisIsRight,
    doYouGetMe,
    noItsYou
  ],
  awards: [
    receivingAwards,
    teamGettingAwards,
    kidsWithTrophies,
    trophies,
    theWinners,
    weAreTheChampions
  ],
  moments: [
    happyMoment,
    friendsMoment,
    funMoment,
    kidsFunCameraMoment,
    smilee,
    momDaughterMoment
  ],
  officials: [
    adjudicators,
    ladyAdjudicator,
    guestSpeaker,
    coaches2
  ],
  events: [
    arrivals,
    arrival2,
    arrival3,
    parade,
    thatsTheStage,
    letsPray
  ]
};

export const affiliateImages = {
  oxford: oxford,
  learning: learning,
  unihawk: unihawk,
  absa: absa,
  toloita: toloita
};

export const statsImages = {
  students: audience,
  competitions: champes,
  achievements: champions,
  innovation: innovation
};

// Export all images as named exports for direct access
export {
  twoStudentsReading,
  aboutSection,
  adjudicators,
  aLadyDebating,
  arrival2,
  arrival3,
  arrivals,
  attentiveToDetails,
  audience,
  aVoiceInACrowd,
  champes,
  champions,
  coaches2,
  congrats,
  coordinators,
  debateCoaches,
  doYouGetMe,
  friendsMoment,
  funMoment,
  guestSpeaker,
  happyMoment,
  hearMeOut,
  iGotThis,
  inAction,
  innovation,
  kidsFunCameraMoment,
  kidsWithTrophies,
  ladyAdjudicator,
  letsPray,
  metANewFriend,
  momDaughterMoment,
  noItsYou,
  oneTeam,
  oneVoice,
  onIt,
  parade,
  pointHome,
  receivingAwards,
  saySomethingOnMic,
  smilee,
  studentDebating,
  studentsInCompetition,
  teacherWithStudentMoment,
  teamGettingAwards,
  thatsTheStage,
  theWinners,
  thisIsRight,
  trophies,
  weAreTheChampions,
  weGonnaWinThis,
  weGotThis,
  logo,
  oxford,
  learning,
  unihawk,
  absa,
  toloita
};

// Default export for easy importing
const assets = {
  hero: heroImages,
  features: featuresBackground,
  programs: programImages,
  testimonials: testimonialImages,
  about: aboutImages,
  gallery: galleryImages,
  stats: statsImages,
  affiliates: affiliateImages
};

export default assets;